import { Box, MenuItem, TextField, Theme, Typography } from '@mui/material';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import { CurrencyObject } from 'common/types';
import { getPricingString } from 'common/utils/common';
import { RentleSegment } from 'common/utils/segments';
import { getSegmentTranslation } from 'common/utils/translations';
import React from 'react';
import { useTranslation } from 'services/localization';

interface Props {
	currency: CurrencyObject;
	segmentOptions: { value: RentleSegment | string; priceDifference: number }[];
	value: RentleSegment | string;
	onSegmentChange: (segment: RentleSegment | string) => void;
}

export const SegmentSelect = (props: Props) => {
	const { currency, segmentOptions, value, onSegmentChange } = props;
	const { t } = useTranslation();
	const classes = useStyles();
	return (
		<TextField
			select
			label={t('shopperCard.ageGroup')}
			value={value}
			onChange={(e) => onSegmentChange(e.target.value as RentleSegment)}
			fullWidth
			variant="outlined"
			margin="none"
		>
			{segmentOptions.map((segment) => {
				const { value, priceDifference } = segment;
				return (
					<MenuItem value={value} key={value}>
						<div className={classes.optionWrapper}>
							<div className={classes.primaryOption}>{getSegmentTranslation(value, t)}</div>
							{priceDifference ? (
								<Typography className={classes.secondaryOption} component="div">
									<Box lineHeight="normal">
										<b>
											{(priceDifference > 0 ? '+' : '') +
												getPricingString(priceDifference, currency)}
										</b>
									</Box>
								</Typography>
							) : null}
						</div>
					</MenuItem>
				);
			})}
		</TextField>
	);
};

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		optionWrapper: {
			width: '100%',
			display: 'flex',
			justifyContent: 'space-between',
			lineHeight: 1,
		},
		primaryOption: {
			flex: 1,
		},
		secondaryOption: {
			textAlign: 'right',
			fontWeight: 400,
		},
	}),
);
